module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAAAQCAYAAABEO2JQAAAAoElEQVRYhe2X4Q6AIAiEo/X+r1z5w81ucMy5ZhjfPyQ2vThKOW+2RGWfvYEvk+IQUhzCMXsDo4jII8YR2ua18crqQ4tTDqaJUdcw78W49itblUNjpzBCizP6F8K6phDaVohmE8yzdaxdRhxNGLSRZStrRi0hDuuYHutV8ZYZyJ6VvFpGaHGsT7EV9woZ3lbe22/njDeT8BnJW7lNaFu9zQUfLmUdLmjkXgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/pjtb1-1.png
// module id = 410
// module chunks = 0